import { mq } from "@/constants/breakpoints";
import Modal from "react-modal";

interface DialogProps extends Modal.Props {}

const Dialog = ({ isOpen, onRequestClose, children }: DialogProps) => {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        className="ModalContent"
        overlayClassName="ModalOverlay"
      >
        {children}
      </Modal>
      <style global jsx>{`
        ${isOpen &&
        `
        body {
          overflow: hidden;
          position: fixed;
        }`}
        .ModalOverlay {
          background: rgba(8, 71, 108, 0.3);
          backdrop-filter: blur(5px);
          padding: 16px;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .ModalContent {
          outline: none;
          border: none;
          background: #fff;
          overflow: auto;
          border-radius: 15px;
          width: fit-content;
          height: fit-content;
          padding: 32px 24px;
          max-width: 462px;
          max-height: calc(100vh - 100px);
          ${mq["lg"]} {
            padding: 30px 40px;
          }
        }
      `}</style>
    </>
  );
};

export default Dialog;
